import classnames from 'classnames'
import { ChangeEvent, ReactNode, useCallback } from 'react'

import styles from './textArea.module.scss'

export enum SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export interface TextAreaProps {
  name: string
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void
  value: string
  needSubmit: boolean
  submitButtonChildren?: ReactNode
  onSubmit?: (value: string) => void
  size?: SIZES
  placeholder?: string
  disabled?: boolean
  className?: string
  rows: number
  cols: number
}

const TextArea = ({
  placeholder = '',
  name,
  disabled = false,
  size = SIZES.MEDIUM,
  onChange,
  onSubmit,
  value,
  submitButtonChildren,
  needSubmit = false,
  className = '',
  rows = 4,
  cols = 20,
}: TextAreaProps) => {
  const wrapperClassName = classnames(
    styles.textAreaWrapper,
    {
      [styles.textArea__disabled]: disabled,
    },
    styles[`btn__${size}`],
    className,
  )

  const handleSubmit = useCallback(() => onSubmit?.(value), [value, onSubmit])

  return (
    <div className={wrapperClassName}>
      <textarea
        name={name}
        placeholder={placeholder}
        rows={rows}
        cols={cols}
        disabled={disabled}
        onChange={onChange}
        value={value}
      />
      {needSubmit && <button onClick={handleSubmit}>{submitButtonChildren}</button>}
    </div>
  )
}

TextArea.SIZES = SIZES

export default TextArea
